/*eslint-disable*/ export const messages = JSON.parse("{\"select.label.optional\":[\"Valfritt\"]}");
//# sourceMappingURL=messages.mjs.map